<template>
    <button @click="$emit('dialogBtn')">teste</button>
</template>

<script>
export default {
    props: {
        dados: Boolean
    },
    data: function() {
        return {
            counter: this.dados
        };
    },
    methods: {
        click() {
            alert(this.counter);
            this.counter = true;
            // this.btnClick != this.btnClick;
        }
    }
};
</script>

<style>
</style>